import { Button, Dialog, DialogActions, DialogContent, FormControlLabel, Grid, Switch } from '@mui/material';
import { CorePermissions } from 'app/appPermissions';
import { MprcConfirmDialog, MprcDialogTitleClose, MprcRequestErrorDialog, MprcRequestIndicator } from 'components';
import { ButtonCancel } from 'components/buttons';
import { useSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import { useSession } from 'providers/SessionProvider';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
    channelId: string;
    channelName: string;
    onClose: (success: boolean) => void;
}

export const DeleteChannel: React.FC<IProps> = (props) => {

    const { channelId, channelName, onClose } = props;

    const api = useCoreApi();
    const { t } = useTranslation("knowledge");
    const { enqueueSnackbar } = useSnackbar();
    const { permissionExplorer } = useSession();

    const [dialog, setDialog] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [viewError, setViewError] = useState<any>(null);
    const [deletePermanently, setDeletePermanently] = useState<boolean>(false);

    const deleteChannel = () => {

        setLoading(true);
        api.v1.channelManagement.deleteChannel({ channelId, deletePermanently }).then(result => {
            if (result.data === true) {
                enqueueSnackbar(t("Channel.List.DeleteChannelSuccessMessage"), {
                    variant: "success"
                });
                onClose(true);
            } else {
                enqueueSnackbar(t("Channel.List.DeleteChannelErrorMessage"), {
                    variant: "error"
                });
            }
        }).catch(e => setViewError(e))
            .finally(() => setLoading(false));

    };

    const handleSwitchDeletePermanently = () => {
        const newValue = !deletePermanently;
        if (newValue == true) {
            setDialog(
                <MprcConfirmDialog
                    open
                    onClose={(yes) => {
                        if (yes) {
                            setDeletePermanently(newValue);
                        }

                        setDialog(null);
                    }}
                    severity="danger"
                    message={t("Channel.List.ConfirmDeleteChannelMessage")}
                />
            );
        } else {
            setDeletePermanently(newValue);
        }
    };

    return <>
        {dialog}
        <MprcRequestIndicator
            visible={loading} type={"post"}
        />

        <MprcRequestErrorDialog
            error={viewError}
            onClose={() => setViewError(undefined)}
        />

        <Dialog
            open
            fullWidth
            maxWidth="sm"
            onClose={() => onClose(false)}
        >
            <MprcDialogTitleClose
                title={t("Channel.List.DeleteChannelTitle")}
                subtitle={channelName}
                onClose={() => onClose(false)}
                shrinkPadding
            />
            <DialogContent>
                <Grid container direction="row" justifyContent="center" spacing={2}>
                    <Grid size={{ xs: 8 }} textAlign="center">
                        {t("Channel.List.ConfirmDeleteChannelMessageL1")}
                        <br />
                        {t("Channel.List.ConfirmDeleteChannelMessageL2")}
                    </Grid>
                    {permissionExplorer.hasOne([CorePermissions.KnowledgeManageTrashCan, CorePermissions.KnowledgeAdmin]) &&
                        <Grid size={{ xs: 12 }} textAlign="center">
                            <FormControlLabel control={<Switch checked={deletePermanently} onChange={handleSwitchDeletePermanently} />} label={t("Channel.List.DeletePermanentlyLabel")} />
                        </Grid>
                    }
                </Grid>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center" }}>
                <ButtonCancel variant="contained" text={t("Channel.List.NoButtonText")} onClick={() => onClose(false)} />
                <Button
                    color="error"
                    variant="contained"
                    onClick={deleteChannel}
                >
                    {t("Channel.List.YesButtonText")}
                </Button>
            </DialogActions>
        </Dialog>
    </>;
};
